import { render, staticRenderFns } from "./ClinicDoctorHours.vue?vue&type=template&id=6cec4271&scoped=true"
import script from "./ClinicDoctorHours.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorHours.vue?vue&type=script&lang=js"
import style0 from "./ClinicDoctorHours.vue?vue&type=style&index=0&id=6cec4271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec4271",
  null
  
)

export default component.exports